module.exports = __webpack_public_path__ + "img/image.09d162fe.png";